import { CircularLoadingProps } from './circular-loading-props'
import classNames from "classnames";
import { useStyles } from "./circular-loading-styles";
import React from 'react';
import { Typography } from '@material-ui/core';

export const CircularLoading = (props: CircularLoadingProps) => {
    const classes = useStyles();

    var myclass =
        props.tipo === 'FULLSIZED' ? classes.fullSized :
            props.tipo === 'ONAUTOCOMPLETE' ? classes.onAutoComplete :
                classes.normal;

    return (
        <>
            <div className={classNames(myclass, "loader-container circle-pulse-multiple", classes.borderColor, props.class)} style={props.style}>
                <div className={classes.loaderCircle}>
                    <div className="loader">
                        <div className="circle-1"></div>
                        <div className="circle-2"></div>
                        <div className="circle-3"></div>
                    </div>
                    {props.tipo === "FULLSIZED" && props.titulo && (
                        <Typography variant="h6" align="center" className={classes.titulo}>
                            {props.titulo}
                        </Typography>
                    )}
                </div>
            </div>
        </>
    )
}
